import { useQuery } from '@tanstack/react-query';
import { catalogosApi } from '@/data/api/catalogosApi';
const STALE = 5 * 60_000;
export function useSucursales() {
    return useQuery({
        queryKey: ['catalogo', 'sucursales'],
        queryFn: () => catalogosApi.sucursales(),
        staleTime: STALE,
    });
}
export function usePuntosVenta(sucursalId) {
    return useQuery({
        queryKey: ['catalogo', 'pdv', sucursalId],
        queryFn: () => catalogosApi.puntosVentaDeSucursal(sucursalId),
        enabled: Boolean(sucursalId),
        staleTime: STALE,
    });
}
export function usePuntosEncuentro(sucursalId) {
    return useQuery({
        queryKey: ['catalogo', 'meeting', sucursalId],
        queryFn: () => catalogosApi.puntosEncuentroDeSucursal(sucursalId),
        enabled: Boolean(sucursalId),
        staleTime: STALE,
    });
}
export function useTarifas(sucursalId) {
    return useQuery({
        queryKey: ['catalogo', 'tarifas', sucursalId],
        queryFn: () => catalogosApi.tarifasDeSucursal(sucursalId),
        enabled: Boolean(sucursalId),
        staleTime: STALE,
    });
}
export function useEmpleados(filtros) {
    const disciplina = filtros?.disciplina || undefined;
    return useQuery({
        queryKey: ['catalogo', 'empleados', disciplina ?? '_'],
        queryFn: () => catalogosApi.empleados({ disciplina }),
        staleTime: STALE,
        enabled: filtros?.enabled ?? true,
    });
}
export function usePromotores(opts) {
    return useQuery({
        queryKey: ['catalogo', 'promotores'],
        queryFn: () => catalogosApi.promotores(),
        staleTime: STALE,
        enabled: opts?.enabled ?? true,
    });
}
